import { Button } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

const VITE_DOCUMENT_PATH =
	import.meta.env.VITE_DOCUMENT_PATH ||
	"https://mill-cmms.roanokesteel.com/vaultix/";

export const DocumentsDownloadButtons = ({ data }: Props) => {
	if (data.id !== -1) {
		const buttonStyle = {
			textDecoration: "none",
			fontWeight: 500,
			fontSize: "11px",
			borderRadius: "3px",
			minWidth: "60px",
			height: "32px",
			whiteSpace: "nowrap" as const,
			overflow: "hidden",
			textOverflow: "ellipsis",
		};

		return (
			<Grid2
				container
				spacing={1}
				style={{
					alignItems: "center",
					justifyContent: "center",
					height: "100%",
				}}
			>
				<Grid2 size={{ xs: 6 }}>
					<Button
						href={`${VITE_DOCUMENT_PATH}${data?.PDFPath}`}
						target="_blank"
						rel="noopener noreferrer"
						fullWidth
						variant="outlined"
						style={{
							...buttonStyle,
							...(data?.PDFPath && {
								border: "1px solid #CC2643",
								color: "#CC2643",
								backgroundColor: "#fff",
							}),
						}}
						disabled={data?.PDFPath === null}
						download={`${data?.DocumentName} ${data?.PDFPath}`}
					>
						PDF
					</Button>
				</Grid2>
				<Grid2 size={{ xs: 6 }}>
					<Button
						href={`${VITE_DOCUMENT_PATH}${data?.DocPath}`}
						target="_blank"
						rel="noopener noreferrer"
						fullWidth
						variant="outlined"
						color="primary"
						style={{
							...buttonStyle,
							...(data?.DocPath && {
								border: "1px solid #1976d2",
								color: "#1976d2",
								backgroundColor: "#fff",
							}),
						}}
						disabled={data?.DocPath === null}
						download={`${data?.DocumentName} ${data?.DocPath}`}
					>
						ORIGINAl
					</Button>
				</Grid2>
			</Grid2>
		);
	}
	return null;
};
